
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignLifebuoy as ObiSignLifebuoyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-lifebuoy.js';
 
 
 

 
 export const ObiSignLifebuoy = createComponent({
   react: React,
   tagName: 'obi-sign-lifebuoy',
   elementClass: ObiSignLifebuoyElement,
   events: {
     
   }
  });
 
 